<template>
    <v-select
        v-model="selectedDisclaimer"
        label="name"
        placeholder="Search..."
        :options="disclaimers"
        @search="onSearch"
    >
        <template slot="no-options">
            Start typing to search for a disclaimer
        </template>
    </v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            selectedDisclaimer: null,
            disclaimers: []
        };
    },

    watch: {
        selectedDisclaimer() {
            this.$emit(
                'input',
                this.selectedDisclaimer ? this.selectedDisclaimer.id : null
            );
        }
    },

    async created() {
        const id = this.value;

        if (!id) {
            return;
        }

        try {
            this.selectedDisclaimer = await this.getDisclaimer(id);

            this.disclaimers.push(this.selectedDisclaimer);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getDisclaimers: 'disclaimers/index',
            getDisclaimer: 'disclaimers/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.disclaimers = this.selectedDisclaimer
                    ? [this.selectedDisclaimer]
                    : [];

                return;
            }

            loading(true);

            try {
                const { rows: disclaimers } = await this.getDisclaimers({
                    search
                });

                if (
                    this.selectedDisclaimer &&
                    disclaimers.every(
                        disclaimer =>
                            disclaimer.id !== this.selectedDisclaimer.id
                    )
                ) {
                    disclaimers.push(this.selectedDisclaimer);
                }

                this.disclaimers = disclaimers;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
